// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Y9Rt","list":"styles_list__19mh7"};